// src/components/ResourceManager/IpBlock/IpData.ts
import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";

export interface IpBlock {
	id: number ;
	name: string;
	ip: string;
	mask: number;
	providerId:number;
	countryId: string;
	operationType: string;
	datacenterId: string | null;
	ipTypeId?: number;
	provider?: {
		name: string;
	};
	country?: {
		name: string;
	};
	ipVersion?: {
		name: string;
	};
	datacenter?: {
		name: string;
	} | null;
}

export const columns: GenericTableColumn<IpBlock>[] = [
	{
		header: "Name/Description",
		accessor: "name",
	},
	{
		header: "Type",
		accessor: "operationType",
	},
	{
		header: "IP",
		accessor: "ip",
	},
	{
		header: "Mask",
		accessor: "mask",
	},
	{
		header: "IP version",
		renderCell: (row) => (row.ipVersion ? row.ipVersion.name : ""),
	},
	{
		header: "Provider",
		renderCell: (row) => (row.provider ? row.provider.name : ""),
	},
	{
		header: "Country",
		renderCell: (row) => (row.country ? row.country.name : ""),
	},
	{
		header: "Actions",
		accessor: "id",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View data center:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit data center:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>

				{/* Delete Button */}
				<button
					className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
					onClick={() => {
						console.log("Delete data center:", row);
					}}
				>
					<IconDelete className="w-5 h-5" />
				</button>
			</div>
		),
	},
];
